export const CustomColorTokens = {
  BRAND_BLUE: "#077397",
  BRAND_GRAY: "#B1BAC3"
};
